"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ShiftsModule = /** @class */ (function () {
    function ShiftsModule() {
    }
    return ShiftsModule;
}());
exports.ShiftsModule = ShiftsModule;
